import { render, staticRenderFns } from "./adset.vue?vue&type=template&id=edf8d5d0&scoped=true"
import script from "./adset.vue?vue&type=script&lang=js"
export * from "./adset.vue?vue&type=script&lang=js"
import style0 from "./adset.vue?vue&type=style&index=0&id=edf8d5d0&prod&lang=scss&scoped=true"
import style1 from "./adset.vue?vue&type=style&index=1&id=edf8d5d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf8d5d0",
  null
  
)

export default component.exports